// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__QPOP1","spin":"Loader_spin__tbbdj"};